import { render, staticRenderFns } from "./ServiceRatesOtsList.vue?vue&type=template&id=13926bf0&scoped=true"
import script from "./ServiceRatesOtsList.vue?vue&type=script&lang=js"
export * from "./ServiceRatesOtsList.vue?vue&type=script&lang=js"
import style0 from "./ServiceRatesOtsList.vue?vue&type=style&index=0&id=13926bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13926bf0",
  null
  
)

export default component.exports